'use client';
import { useState } from 'react';
import { TableViewerLayout } from '@components/TableViewerLayout/TableViewerLayout';
import { AllReports } from './AllReports';

const ReportsPage = () => {
  const [tableTitle, setTableTitle] = useState('Current Stream Status');

  return (
    <TableViewerLayout
      tableTitle={tableTitle}
      tableSlot={<AllReports setTableTitle={setTableTitle} />}
    />
  );
};

export default ReportsPage;